import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/Base/Dialog";
import { Employee } from "@/types/v2";
import { Button } from "@/components/Base/Button";
import { employee as employeeActions } from "@/repositories/employee";
import { captureException } from "@/services/sentry";
import { user as userActions } from "@/repositories/user";

interface DeleteEmployeeDialogProps {
  shopId: string;
  employee: Employee;
  open: boolean;
  setOpen: (arg: boolean) => void;
  authStatus?: "active" | "inactive" | "doesNotExist";
  onDelete?: () => void;
  onComplete?: () => void;
}
export const DeleteEmployeeDialog = ({
  employee,
  shopId,
  open,
  setOpen,
  authStatus,
  onDelete,
  onComplete,
}: DeleteEmployeeDialogProps) => {
  const handleDelete = async () => {
    if (onDelete) {
      onDelete();
    }
    try {
      if (authStatus === "active") {
        await userActions.deactivateAuthAccount(employee.email);
        await employeeActions.updateEmployeeRole(shopId, employee.id);
      }
      await employeeActions.softDelete(shopId, employee.id);
    } catch (error) {
      captureException(error);
    }
    setOpen(false);
    if (onComplete) {
      onComplete();
    }
  };
  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <Dialog onOpenChange={setOpen} open={open}>
      <DialogContent className="max-w-screen-md">
        <DialogHeader>
          <DialogTitle>Delete Team Member</DialogTitle>
        </DialogHeader>
        <DialogDescription className={"text-base"}>
          {`You are about to delete ${employee.firstName} ${employee.lastName}. Are you sure you want to continue? `}
        </DialogDescription>
        <DialogDescription>
          If this is an employee from your integration, you need to also
          deactivate their account in your integration.
        </DialogDescription>
        <DialogFooter>
          <div className="mt-5">
            <Button
              className="mr-5 mt-5"
              variant={"secondary"}
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button
              className="mt-5"
              variant={"destructive"}
              onClick={handleDelete}
            >
              Delete
            </Button>
          </div>
        </DialogFooter>

        <DialogFooter></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
